module.exports = __webpack_public_path__ + "static/img/team-business.5237c486.png";